function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 8.00003C0 3.58175 3.58175 0 8 0C12.4183 0 16 3.58175 16 8.00003",
  fill: "#D80027"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.86967 4.17389C4.86967 3.00832 5.68882 2.03464 6.7827 1.79573C6.61457 1.75904 6.44017 1.73914 6.26095 1.73914C4.91623 1.73914 3.82617 2.8292 3.82617 4.17392C3.82617 5.51864 4.91623 6.6087 6.26095 6.6087C6.4401 6.6087 6.61454 6.58879 6.7827 6.55207C5.68882 6.31317 4.86967 5.33948 4.86967 4.17389Z",
  fill: "#F0F0F0"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99999 1.91309L8.17268 2.44449H8.73146L8.27937 2.77296L8.45205 3.30437L7.99999 2.97596L7.54793 3.30437L7.72062 2.77296L7.26855 2.44449H7.8273L7.99999 1.91309Z",
  fill: "#F0F0F0"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.64459 2.95642L6.81724 3.48786H7.37602L6.92396 3.8163L7.09665 4.3477L6.64459 4.0193L6.19246 4.3477L6.36518 3.8163L5.91309 3.48786H6.47187L6.64459 2.95642Z",
  fill: "#F0F0F0"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.35546 2.95642L9.52818 3.48786H10.0869L9.63484 3.8163L9.80755 4.3477L9.35546 4.0193L8.9034 4.3477L9.07609 3.8163L8.62402 3.48786H9.18277L9.35546 2.95642Z",
  fill: "#F0F0F0"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.83398 4.52173L9.00666 5.05317H9.56541L9.11335 5.3816L9.28604 5.91301L8.83398 5.5846L8.38191 5.91301L8.5546 5.3816L8.10254 5.05317H8.66126L8.83398 4.52173Z",
  fill: "#F0F0F0"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M7.16653 4.52173L7.33918 5.05317H7.898L7.4459 5.3816L7.61862 5.91301L7.16653 5.5846L6.71443 5.91301L6.88712 5.3816L6.43506 5.05317H6.99384L7.16653 4.52173Z",
  fill: "#F0F0F0"
});
const SvgSingapore = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSingapore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/singapore.a9cf2754.svg";
export { ForwardRef as ReactComponent };